/* global moment,XLSX */
angular
  .module('statWash')
  .component('statWash', {
    template: require('./stat-wash.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatWashController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'wash';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.isLoading = true;
        this.from_date = moment().startOf('month').format('YYYY-MM-DD');
        this.to_date = moment().endOf('month').format('YYYY-MM-DD');
        this.tbUserIdEmployee = '-1';

        const promiseWashCount = () => $resource(`${APIURL}/admin/stat/wash/counts`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washCount = data.washCount;
        });

        const promiseWashCountByGoods = () => $resource(`${APIURL}/admin/stat/wash/counts/bygoods`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByGoodsCount = data.washByGoodsCount;
        });

        const promiseWashCountByOptions = () => $resource(`${APIURL}/admin/stat/wash/counts/byoptions`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByOptionsCount = data.washByOptionsCount;
        });

        const promiseWashCountByMethods = () => $resource(`${APIURL}/admin/stat/wash/counts/bymethods`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByMethodsCount = data.washByMethodsCount;
        });

        const promiseWashCountByWeekday = () => $resource(`${APIURL}/admin/stat/wash/counts/byweekday`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByWeekDayCount = data.washByWeekDayCount;
        });

        const promiseWashCountByHours = () => $resource(`${APIURL}/admin/stat/wash/counts/byhours`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByHoursCount = data.washByHoursCount;
        });

        const promiseWashCountByEmployees = () => $resource(`${APIURL}/admin/stat/wash/counts/byemployees`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByEmployeesCount = data.washByEmployeesCount;
        });

        $scope.reload = () => {
          this.isLoading = true;
          const promises = [promiseWashCount(), promiseWashCountByGoods(), promiseWashCountByOptions(), promiseWashCountByMethods(), promiseWashCountByWeekday(), promiseWashCountByHours(), promiseWashCountByEmployees()];
          Promise.all(promises).then(() => {
            console.log('loading completed');
            this.isLoading = false;
            $scope.$apply();
          })
            .catch((err) => {
              console.error(err);
              this.isLoading = false;
              $scope.$apply();
            });
        };

        $scope.onDatePick = () => {
          console.log('onDatePick');
          this.from_date = jQuery('#inputPickerFrom').val();
          this.to_date = jQuery('#inputPickerTo').val();
          $scope.reload();
        };

        $scope.reload();

        // fetch employee list
        $resource(`${APIURL}/admin/employees`).get({ count: 10000, include_unregister: false }, (data) => {
          $scope.employees = data.users;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });

        this.download = (data, name = 'default') => {
          data = angular.copy(data);
          if (!Array.isArray(data)) {
            data = [data];
          }
          const ws = XLSX.utils.json_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, name);
          /* write workbook and force a download */
          XLSX.writeFile(wb, `${name}_${this.from_date}_${this.to_date}.xlsx`);
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-wash/stat-wash.component.js